var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-black"},[_c('a',{staticClass:"btn-secondary",attrs:{"href":_vm.href}},[_c('i',{staticClass:"fa fa-floppy-o"}),_vm._v(" Excel")])])}
var staticRenderFns = []

export { render, staticRenderFns }